import { render, staticRenderFns } from "./QuickTask.vue?vue&type=template&id=b58fc588&scoped=true&"
import script from "./QuickTask.vue?vue&type=script&lang=js&"
export * from "./QuickTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58fc588",
  null
  
)

export default component.exports